import { IInsightAction } from '@jumpstart/core';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { headerCase } from 'change-case';
import { FieldArray } from 'formik';
import React, { useState } from 'react';

import JSONInput from 'react-json-editor-ajrm';
import { assertJson } from '../../../core/utils';


export interface IDialogFormActionsField {
  values: any;
  classes: any;
  handleChange: any;
  setFieldValue: any;
}

const ACTION_SCHEMAS: { [id: string]: { schema: object, initial: object } } = {
  'NONE': {
    schema: {},
    initial: {}
  },
  'INSIGHT_ADD': {
    schema: {
      type: "object",
      properties: {
        insight: {type: "string"},
        reroute: {type: "boolean"}
      },
      required: ["insight"],
      // additionalProperties: false
    },
    initial: {
      insight: null,
      reroute: false
    }
  }
};

function DialogFormActionField(props: IDialogFormActionsField & { index: number; action: IInsightAction; arrayHelpers: any }) {
  const { classes, setFieldValue, index, action, arrayHelpers } = props;
  const [error, setError] = useState<{ reason: string | undefined; line: number } | null>(null);
  return (
    <Grid container direction="column" style={{marginBottom: 12}}>

    <Grid container direction="row" wrap="nowrap" sx={classes.input}>

      <TextField
        sx={classes.input}
        key={`actions[${index}].code`}
        id={`actions[${index}].code`}
        name={`actions[${index}].code`}
        label={`Action Code`}
        value={action.code}
        onChange={(event) => {
          console.log(event);
          setFieldValue(`actions[${index}].code`, event.target.value);
          setFieldValue(`actions[${index}].meta`, ACTION_SCHEMAS[event.target.value].initial);
        }}
        select
        variant="outlined"
      >
        {
          Object.keys(ACTION_SCHEMAS)
            .map((key: string) => <MenuItem
                key={`actions[${index}].code.${key}`}
                value={key}
              >
                {headerCase(key)}
              </MenuItem>
            )
        }
      </TextField>

      <Grid item>

      <IconButton onClick={() => arrayHelpers.remove(index)}><CloseIcon/></IconButton>
      </Grid>


    </Grid>
      {
        ACTION_SCHEMAS.hasOwnProperty(action.code) && action.code !== 'NONE' &&
        <JSONInput
          id={`actions[${index}].meta`}
          placeholder={action.meta}
          height='150px'
          onChange={(event: any) => {
            // console.log('CHANGES', event);
            const errors: any[] | null = assertJson(
              ACTION_SCHEMAS[action.code].schema,
              event.jsObject
            );
            if (errors && errors.length > 0) {
              setError({ reason: errors[0].message, line: errors[0].line + 1});
            } else {
              setFieldValue(`actions[${index}].meta`, event.jsObject);
            }
          }}
          error={error}
        />
      }

    </Grid>
  );
}

export default function DialogFormActionsField(props: IDialogFormActionsField) {
  const { values, classes, handleChange, setFieldValue } = props;
  return (
    <FieldArray
      name={`actions`}>
      {(arrayHelpers) =>
        <Grid container direction="column">
          {(values.actions ? values.actions : []).map((action: IInsightAction, index: number) =>
            <DialogFormActionField
              key={`actions[${index}]`}
              arrayHelpers={arrayHelpers}
              index={index}
              action={action}
              values={values}
              classes={classes}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
            />
          )}
          <Grid item container>
            <Button
              startIcon={<AddIcon/>}
              onClick={() => {
                console.log('Adding tip...');
                arrayHelpers.push({
                  code: 'NONE',
                  meta: ACTION_SCHEMAS['NONE'].initial
                });
              }}
            >
              Add Action
            </Button>
          </Grid>

        </Grid>
      }
    </FieldArray>
  );
}
